<template>
  <div class="jobs-list columns is-desktop is-multiline">
    <div v-for="item in list" :key="item.id" class="column is-6-desktop">
      <jobs-card-panel
        :title="item.title"
        :company-type="item.company_type"
        :industry="item.industry"
        :area="item.area"
        :job-code="item.code"
        :location="item.location"
        :annual-salary="getFormattedAnnualSalary(item.annual_salary, item.annual_salary_currency)"
        :description="item.description"
        :posted-on-date="getFormattedPostedOnDate(item.open_date)">
      </jobs-card-panel>
    </div>
    <div v-if="loading" class="column is-12-desktop">
      <jobs-loader ></jobs-loader>
    </div>
    <div v-else-if="canShowMoreJobs" class="button-block">
      <ghost-button-with-icon
        :title="labels.loadMore"
        :handler="handleLoadMoreJobs"
        :customClasses="'button button-load-more is-primary-ghost-small'">
      </ghost-button-with-icon>
    </div>
  </div>
</template>

<script>

import GhostButtonWithIcon from 'top20common/components/buttons/GhostButtonWithIcon';
import currencies from 'top20common/distribution/services/currencies';

import JobsCardPanel from './JobsCardPanel';
import JobsLoader from './JobsLoader';

export default {
  props: {
    list: Array,
    loading: Boolean,
    totalListCount: Number
  },
  computed: {
    labels() {
      return {
        loadMore: this.$gettext('Load more')
      };
    },
    canShowMoreJobs() {
      return this.totalListCount > this.list.length;
    }
  },
  methods: {
    getFormattedAnnualSalary(salary, currency) {
      return salary ? currencies.getShortFormatNumberWithCurrency(salary, currency) : '';
    },
    getFormattedPostedOnDate(date) {
      let label = this.$gettext('Posted on %{date}');
      return date
        ? this.$gettextInterpolate(label, {
            date: this.$language.getFormattedDate(date, 'MMMM DD')
          })
        : '';
    },
    handleLoadMoreJobs() {
      this.$emit('load-more-click');
    }
  },
  components: {
    JobsCardPanel,
    GhostButtonWithIcon,
    JobsLoader
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.jobs-list {
  .button-block {
    margin: 0 auto;
    padding: 30px 0 50px;
    text-align: center;

    .button-load-more {
      width: auto;

      /deep/ .btn-flex-row .btn-flex-item:first-child {
        display: none;
      }
    }
  }
}

@media (max-width: $tablet) {
  .jobs-list > div {
    padding: 10px 0;
  }
}
</style>
